module.exports = __webpack_public_path__ + "img/team-person-5.15415cfb.png";